<template>
    <div>
        <icon-no-data-cry
            v-if="!hideEmptyIcon"
            class="w-64"
        />
    </div>
</template>

<script>
import get from "lodash/get";

export default {
    name: 'WidgetNoData',
    props: {
        widget: {
            type: Object,
            required: true
        }
    },
    computed: {
        hideEmptyIcon () {
            return get(this.widget, 'WidgetLayout.TemplateSettings.HideEmptyIcon', false)
        }
    }
}
</script>

<style scoped lang="scss">

</style>
